import React, { CSSProperties } from 'react'
import { AppIcon, variantProvider } from '@/app'
import { Text, View } from '@/components'
import { TypeGuards } from '@codeleap/types'
import { CommunityFeed, Post } from '@/types'
import { TagType } from './TagType'
import { feedIconsMap } from '../constants'
import { LessonReference } from './LessonReference'

export type TextBubbleProps = {
  title?: string
  description?: string
  icon?: AppIcon
  header?: React.ReactNode
  children?: React.ReactNode
  style?: CSSProperties
  lesson?: Post['lesson']
}

export function TextBubble(props: TextBubbleProps) {
  const { description, title, style, header, children, icon, lesson } = props

  return (
    <View css={[styles.textPreview, style]}>
      <View variants={['row', 'fullWidth', 'justifySpaceBetween']}>
        <TagType icon={icon} />
        {header}
      </View>

      {title ? <Text text={title} variants={['h2', 'bold']} /> : null}
      {description ? <Text text={description} variants={['p1', 'color:neutral6', 'regular']} /> : null}
      {children}
      <LessonReference lesson={lesson} />
    </View>
  )
}

function getTextOverlayProps(item: CommunityFeed) {
  return item.type.includes('_answer') ? item.prompt : item.post
}

TextBubble.extractProps = (
  item: CommunityFeed['post'] | CommunityFeed['prompt'] | CommunityFeed | null | undefined,
) => {
  if (!item || !TypeGuards.isObject(item)) return {}

  const base = 'type' in item ? getTextOverlayProps(item) : item

  return {
    title: base?.title,
    description: base?.description,
    // @ts-ignore
    top_comment: item?.top_comment,
    icon: feedIconsMap[item.type] || null,
  }
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    textPreview: {
      ...theme.presets.column,
      ...theme.spacing.padding(3),
      borderRadius: theme.borderRadius.medium,
      backgroundColor: theme.colors.neutral2,
    },
  }),
  true,
)
